import React, { Component } from 'react';

// import logo from '../../../../images/LOGO_PATHE.png';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { startLogin, startQuiz } from "../../../store/actions/appstate";
import Config from "../../../../config/config";
// import { BrowserRouter as Router } from 'react-router-dom';

export class CodeLogin extends Component {

	constructor(props) {
        super(props);
        // this.state = {userCode: this.props.match.params.id};
        console.log('set the code to:', this.props.match.params.id)
        console.log("history", this.props.history)
        this.buttonClicked = this.buttonClicked.bind(this);

    }
    
    componentDidMount() {
        console.log('component did mount!')
        // this.props.setUserCode(this.props.match.params.id);
        this.props.startQuiz();
        window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Login-Code',
			'page_path': '/login/code'
		});
    }

    buttonClicked() {
        console.log('butotn clicked');
        this.props.history.push("/question");
    }

	render() {
        return(
            <div className="enterbioscode">
                Welcome, { this.props.user.code }!
                <p>App state: { this.props.appstate }</p>
                <button onClick={this.buttonClicked}>Button</button>
            </div>
        )
    }
}

		

function mapStateToProps(state) {
    return {
        appstate: state.appstate,
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return {
        startLogin: bindActionCreators(startLogin, dispatch),
        startQuiz: bindActionCreators(startQuiz, dispatch)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CodeLogin)


// WEBPACK FOOTER //
// ./src/components/pages/Login/CodeLogin/CodeLogin.js